import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  Card
} from "@mui/material/";
import { QueryAPI } from "API/QueryAPI";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import { style } from "style";
import { checkResponse } from "helpers/notification";
import moment from 'moment';
import CustomExport from "components/CustomExport";
import { useLocation } from 'react-router-dom';
import AlertNoRecordFound from "components/AlertNoRecordFound";
import AlertLoading from "components/AlertLoading";

function PhoneSearchDetail(props) {

  const [phoneReport, setPhoneReport] = useState(null);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const location = useLocation();
  const { queryId, requestParameters } = location.state || {};

  var userName = useSelector(state => state.common.userName);

  const [isLoading, setIsLoading] = useState(true);

  const numberFormatter = new Intl.NumberFormat('tr-TR');

  const createColumns = async e => {
    setColumns([
      {
        headerName: "Id", field: "id", flex: 0, hide: true, disableExport: true,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.id}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Kullanıcı Adı",
        field: "loginName",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.loginName}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Mesaj Başlığı",
        field: "sender",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.sender}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Gönderim Adı",
        field: "msgSpecialId",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.msgSpecialId === null ? "" : params.row.msgSpecialId}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Telefon",
        field: "msisdn",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.msisdn}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Durum",
        field: "msgStatus",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.msgStatus}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Hata Kodu",
        field: "errCode",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.errCode}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Hata Kodu Açıklaması",
        field: "customDescription",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.customDescription}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Kontör",
        field: "contor",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.contor}
            </MDTypography>
          );
        }
      },
      {
        headerName: "Tarih",
        field: "sendDate",
        flex: 1,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.sendDate}
            </MDTypography>
          );
        }
      },
      {
        headerName: "İçerik",
        field: "content",
        flex: 2,
        hide: true,
        renderCell: params => {
          return (
            <MDTypography sx={style.gridTextStyle} color='text' fontWeight='regular' fontSize='12px'>
              {params.row.content}
            </MDTypography>
          );
        }
      },
    ]);
  };

  const createRows = async e => {
    const rowsData = [];

    if (phoneReport.length > 0) {
      phoneReport.map((data, index) =>
        rowsData.push({
          id: index + 1,
          loginName: data.loginName,
          sender: data.sender,
          msgSpecialId: data.msgSpecialId,
          msisdn: data.msisdn,
          msgStatus: data.msgStatus,
          errCode: data.errCode,
          customDescription: data.customDescription,
          contor: numberFormatter.format(data.contor),
          sendDate: moment(data.sendDate).format("YYYY-MM-DD HH:mm"),
          content: data.content
        })
      );
    }

    setRows(rowsData);
    setIsLoading(false);
  };

  const getQueryData = async () => {
    setIsLoading(true);
    setRows([]);
    setPhoneReport(null);
    const getQueryDataResponse = await QueryAPI.GetQueryData(queryId, "phonesearch");
    if (checkResponse(getQueryDataResponse, null, "Detay Rapor getirme işlemi başarısız oldu")) {
      let res = getQueryDataResponse.data.resultObject;
      setPhoneReport(res);
    } else {
      setPhoneReport([]);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getQueryData();
  }, [queryId]);

  useEffect(() => {
    if (phoneReport === null) return;
    createColumns();
    createRows();
  }, [phoneReport]);

  useEffect(() => {
    const onRefresh = async () => {
      await getQueryData();
    };

    window.addEventListener("pageRefreshRequested", onRefresh);
    return () => window.removeEventListener("pageRefreshRequested", onRefresh);
  }, [queryId]);


  return (
    <DashboardLayout>
      <DashboardNavbar />
      {
        isLoading ? (
          <AlertLoading text="Numara Sorgulama Raporu Yükleniyor..." />
        ) : phoneReport.length > 0 ? (<MDBox pt={3} pb={1}>
          <Grid container spacing={6}>
            <Grid item xs={12}>
              <Card>
                <MDBox mx={2} mt={-3} py={1} px={2} variant='gradient' bgColor='info' borderRadius='lg' coloredShadow='info'>
                  <MDTypography variant='h6' color='white'>
                    Numara Sorgu Raporu
                  </MDTypography>
                  <MDTypography style={{ fontSize: "13px" }} color='white'>
                    Numara bazında sorgulama sonuçlarını aşağıdan takip edebilirsiniz.
                  </MDTypography>
                </MDBox>
                <MDBox pt={3}>
                  <CustomExport
                    rows={rows}
                    columns={columns}
                    exportFileName={userName
                      + "_NumaraRaporu_"
                      + moment(new Date()).format('YYYYMMDDHHmmss').toString()}
                    contentFieldName="content"
                  />
                </MDBox>
              </Card>
            </Grid>
          </Grid>
        </MDBox>) : (
          <AlertNoRecordFound />

        )
      }
    </DashboardLayout>
  )
}

export default PhoneSearchDetail;